import { Title } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

import { BottomSheetHeader } from "../../../components/BottomSheetHeader";

interface SelectionHeaderProps {
  requiredShiftCount: number;
  totalShiftCount: number;
  onBack: () => void;
}

export function SelectionHeader(props: SelectionHeaderProps) {
  const { requiredShiftCount, totalShiftCount, onBack } = props;

  const isConfirmationMode = requiredShiftCount === totalShiftCount;

  return (
    <Stack>
      <BottomSheetHeader onBack={onBack} />
      <Stack sx={{ paddingX: 6, paddingTop: 5, paddingBottom: 7, alignItems: "center" }}>
        <Title variant="h3" component="h2" sx={{ textAlign: "center" }}>
          {isConfirmationMode
            ? "Confirm your bundle details"
            : `Select at least ${requiredShiftCount} shifts`}
        </Title>
      </Stack>
    </Stack>
  );
}
